import React from 'react';
import type { PlateDirection } from '../../utils/api';

const DIRECTION_LABELS: Record<PlateDirection, { label: string; className: string; title: string }> = {
  entry: { label: 'Въезд', className: 'ui-badge--success', title: 'Проезд по направлению вектора въезда' },
  exit: { label: 'Выезд', className: 'ui-badge--danger', title: 'Проезд против направления вектора въезда' },
  unknown: {
    label: 'Не определено',
    className: 'ui-badge--outline',
    title: 'Вектор задан, но направление не распознано — например, автомобиль не двигался',
  },
};

interface DirectionBadgeProps {
  direction: PlateDirection | null | undefined;
}

/**
 * Бейдж направления проезда для LPR-детекций.
 * null/undefined — у камеры нет вектора (или это не LPR): ничего не показываем.
 * «Не определено» бэкенд присылает только когда вектор нарисован, но направление не распозналось.
 */
export const DirectionBadge: React.FC<DirectionBadgeProps> = ({ direction }) => {
  if (direction !== 'entry' && direction !== 'exit' && direction !== 'unknown') {
    return null;
  }

  const meta = DIRECTION_LABELS[direction];
  return (
    <span className={`ui-badge ${meta.className}`} title={meta.title}>
      {meta.label}
    </span>
  );
};

export default DirectionBadge;
